// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__Npnt0","current":"style_current__2GbbA","arrow":"style_arrow__rfc9L"};